// eslint-disable-next-line import/prefer-default-export
export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
